import React, { useContext, useState, createContext } from "react";
import { ref, child, get, getDatabase } from "firebase/database";
import GetAuth from "./GetAuth";

const APIContext = createContext();

export function APIContextProvider({ children }) {
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [data, setData] = useState();
	React.useEffect(() => {
		get(child(dbRef, "michelsonaristhyl"))
			.then((snapshot) => {
				setData(snapshot.val());
			})
			.catch((error) => {
				console.log(error);
			});
	}, [dbRef]);

	return (
		<APIContext.Provider
			value={{
				data: data,
			}}>
			{children}
		</APIContext.Provider>
	);
}

export function useAPI() {
	const context = useContext(APIContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
}
